import * as React from 'react';
import { Styled } from 'theme-ui';
import { keyframes } from '@emotion/react';
import LoadingOverlay from 'react-loading-overlay';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

/** @jsx jsx */
import { jsx } from 'theme-ui';

export interface Props {
  active?: boolean;
  loading?: boolean;
  children?: any;
  onSuccess?: () => void;
}

const spin = keyframes`
  100% {
    transform:rotate(360deg);
  }
`;

const Spinner = () => (
    <div sx={{
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: 'light',
        width: ['100%', '100%', '100%', '28em', '28em', '28em'],
        height: ['7em', '7em', '7em', '10em', '10em', '10em'],
        background: 'white',
        margin: '0 auto'
    }}>
        <div sx={{
            ml: '2em',
            my: '0.9em',
            animation: `${spin} 1s infinite linear`,
            border: 'solid 1em transparent',
            borderRadius: '50%',
            borderRightColor: 'primary',
            borderTopColor: 'primary',
            boxSizing: 'border-box',
            height: ['5em', '5em', '5em', '8em', '8em', '8em'],
            width: ['5em', '5em', '5em', '8em', '8em', '8em'],
            zIndex: '1'
        }}>
            <div sx={{
                animation: `${spin} 2s infinite linear`,
                border: 'solid 1em transparent',
                borderRadius: '50%',
                borderRightColor: 'spinner_2',
                borderTopColor: 'spinner_2',
                boxSizing: 'border-box',
                content: '""',
                height: ['3em', '3em', '3em', '6em', '6em', '6em'],
                left: 0,
                position: 'absolute',
                top: 0,
                width: ['3em', '3em', '3em', '6em', '6em', '6em']
            }} />
            <div sx={{
                animation: `${spin} 3s infinite linear`,
                borderStyle: 'solid',
                borderColor: 'transparent',
                borderWidth: ['8px', '8px', '8px', '1em', '1em', '1em'],
                borderRadius: '50%',
                borderRightColor: 'spinner_3',
                borderTopColor: 'spinner_3',
                boxSizing: 'border-box',
                content: '""',
                height: ['1em', '1em', '1em', '4em', '4em', '4em'],
                left: '1em',
                position: 'absolute',
                top: '1em',
                width: ['1em', '1em', '1em', '4em', '4em', '4em']
            }}/>
        </div>
        <Styled.h2 sx={{
          mt: ['-3.5em', '-3.5em', '-3.5em', '-4.5em', '-4.5em', '-4.5em'],
          mr: ['-5em', '-5em', '-5em', '-4em', '-4em', '-4em']
        }}>
          <FormattedMessage id="spinner.loading" />
        </Styled.h2>
  </div>
);

export function LoadingSpinner({ active, children, loading, onSuccess }: Props): React.JSX.Element {

  useEffect((): void => {
    if ((active === false) && (loading === false)) {
      onSuccess();
    }
  }, [active, loading, onSuccess]);

  return <div sx={{
    '._loading_overlay_content': {
      margin: '0',
      right: ['0', '0', '0', '25%', '25%', '25%'],
      left: ['0', '0', '0', '25%', '25%', '25%'],
      top: ['37%', '37%', '37%', '39%', '39%', '39%'],
      position: 'fixed',
    },
    '._loading_overlay_overlay': {
      background: 'rgba(0, 0, 0, 0.3)'
    }
  }}>
      <LoadingOverlay
        active={active}
        fadeSpeed={100}
        spinner={<Spinner />}
      >
        {children}
      </LoadingOverlay>
    </div>;
}
